module.exports = __webpack_public_path__ + "img/دفتر-یادداشت--پلاستیکی.42b4bb6e.png";